import events from './events'
import store from 'reducers'
import Actions from './Actions'

export default class ShiftActions extends Actions{
    static get target(){
        return 'shifts'
    }

    static fetch (data) {
        return this.client.organizations.shifts.fetch(data).then((response)=>{
            let shifts = Object.values(response.data).reduce((acc, shift)=>{
                acc[`${shift.administratorID}`] = {
                    ...(acc[`${shift.administratorID}`] || {}),
                    [`${shift.repeatingID || shift.id}`]: shift
                }
                return acc
            },{})

            for(let adminID of Object.keys(shifts)){
                shifts[adminID] = {
                    ...shifts[adminID],
                    ...store.getState().shifts[adminID]
                }
            }
            
            ShiftActions.append(shifts)
        })
    }

    static append(data){
        this.appendMany(data)
    }
}


// WEBPACK FOOTER //
// ./actions/ShiftActions.js